<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="优惠券名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入优惠券名称" />
      </a-form-model-item>
      <a-form-model-item label="优惠券满额" prop="require" >
        <a-input-number v-model="form.require" :min="0" :precision="2" placeholder="满多少元可用" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="优惠券金额" prop="price" >
        <a-input-number v-model="form.price" :min="0" :precision="2" placeholder="抵扣金额（元）" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="过期类型" prop="expiryType">
        <a-radio-group v-model="form.expiryType" @change="handleExpiryTypeChange">
          <a-radio :value="1">
            固定时间
          </a-radio>
          <a-radio :value="2">
            领取后N天过期
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.expiryType === 1" label="开始时间" prop="validityStart">
        <a-date-picker
          v-model="form.validityStart"
          style="width: 100%"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="true"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item v-if="form.expiryType === 1" label="结束时间" prop="validityEnd">
        <a-date-picker
          v-model="form.validityEnd"
          style="width: 100%"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :show-time="true"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item v-if="form.expiryType === 2" label="有效天数" prop="effective">
        <a-input-number v-model="form.effective" :min="1" placeholder="请输入有效天数" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCoupon, addCoupon, updateCoupon } from '@/api/coupon/coupon'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        require: null,

        price: null,

        expiryType: 2,

        validityStart: null,

        validityEnd: null,

        effective: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '优惠券名称不能为空', trigger: 'blur' }
        ],
        require: [
          { required: true, message: '优惠券满额不能为空', trigger: 'blur' },
          { validator: this.validateRequire, trigger: 'change' }
        ],
        price: [
          { required: true, message: '优惠券金额不能为空', trigger: 'blur' },
          { validator: this.validatePrice, trigger: 'change' }
        ],
        expiryType: [
          { required: true, message: '过期类型不能为空', trigger: 'change' }
        ],
        effective: [
          { validator: this.validateEffective, trigger: 'change' }
        ],
        validityStart: [
          { validator: this.validateValidityStart, trigger: 'change' }
        ],
        validityEnd: [
          { validator: this.validateValidityEnd, trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        require: null,
        price: null,
        expiryType: 2,
        validityStart: null,
        validityEnd: null,
        effective: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : (Array.isArray(ids) ? ids[0] : ids)
      getCoupon({ 'id': id }).then(response => {
        const data = response.data || {}
        this.form = {
          id: data.id || null,
          name: data.name || null,
          require: data.require,
          price: data.price,
          expiryType: data.expiryType ? Number(data.expiryType) : 2,
          validityStart: data.validityStart || null,
          validityEnd: data.validityEnd || null,
          effective: data.effective,
          createTime: data.createTime || null,
          remark: data.remark || null
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    handleExpiryTypeChange (e) {
      const value = e && e.target ? e.target.value : e
      this.form.expiryType = value
      if (value === 1) {
        this.form.effective = null
      } else {
        this.form.validityStart = null
        this.form.validityEnd = null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate(['effective', 'validityStart', 'validityEnd'])
        }
      })
    },
    validateEffective (rule, value, callback) {
      if (this.form.expiryType === 2 && (value === null || value === undefined || value === '')) {
        callback(new Error('有效天数不能为空'))
        return
      }
      callback()
    },
    validateRequire (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      if (Number(value) <= 0) {
        callback(new Error('优惠券满额必须大于0'))
        return
      }
      if (this.form.price !== null && this.form.price !== undefined && Number(value) < Number(this.form.price)) {
        callback(new Error('优惠券满额不能小于优惠券金额'))
        return
      }
      callback()
    },
    validatePrice (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      if (Number(value) <= 0) {
        callback(new Error('优惠券金额必须大于0'))
        return
      }
      if (this.form.require !== null && this.form.require !== undefined && Number(value) > Number(this.form.require)) {
        callback(new Error('优惠券金额不能大于满额条件'))
        return
      }
      callback()
    },
    validateValidityStart (rule, value, callback) {
      if (this.form.expiryType === 1 && !value) {
        callback(new Error('开始时间不能为空'))
        return
      }
      if (this.form.expiryType === 1 && value && this.form.validityEnd && value >= this.form.validityEnd) {
        callback(new Error('开始时间必须早于结束时间'))
        return
      }
      callback()
    },
    validateValidityEnd (rule, value, callback) {
      if (this.form.expiryType === 1 && !value) {
        callback(new Error('结束时间不能为空'))
        return
      }
      if (this.form.expiryType === 1 && value && this.form.validityStart && value <= this.form.validityStart) {
        callback(new Error('结束时间必须晚于开始时间'))
        return
      }
      callback()
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const formData = {
            ...this.form,
            effective: this.form.expiryType === 2 ? this.form.effective : null,
            validityStart: this.form.expiryType === 1 ? this.form.validityStart : null,
            validityEnd: this.form.expiryType === 1 ? this.form.validityEnd : null
          }
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCoupon(formData).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCoupon(formData).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
